import React from "react";
import content from 'content.json';
import { Card, CardBody, Row, Col } from "reactstrap";

function Privacy() {
  const sections = [
    {
      num: 1,
      title: "Information We Collect",
      content: `When you log into ${content.brandname} using Google, we only collect your name as provided by the Google login functionality. This name is solely used to identify your ${content.application} tokens, which allow us to retrieve your latest ${content.entries}. We strictly adhere to ${content.application}'s API guidelines and only request read permissions from your ${content.application} account.`
    },
    {
      num: 2,
      title: `Use of ${content.application} Data`,
      content: `${content.brandname} will not modify or store your ${content.entries}. Instead, we use tokens to securely pull your latest ${content.entries} as needed. The data is displayed to you during your session and is not stored in our system. We ensure that our use of your data complies with ${content.application}'s API agreement, which prohibits sharing, selling, or using the data for purposes such as training AI models.`
    },
    {
      num: 3,
      title: "Data Storage and Security",
      content: `The tokens we collect to access your ${content.application} data are securely stored in our Azure backend infrastructure. We implement industry-standard security measures, including encryption and secure transmission (e.g., HTTPS), to protect your data. We are committed to respecting your privacy settings, as defined in your ${content.application} account, and complying with all applicable data protection laws.`
    },
    {
      num: 4,
      title: "User Control",
      content: `You have full control over the data you share with ${content.brandname}. At any time, you can revoke ${content.brandname}'s access to your ${content.application} account by adjusting your permissions in ${content.application}. Additionally, if you choose to stop using our services, all tokens and access data will be deleted from our system upon request.`
    },
    {
      num: 5,
      title: "Changes to this Privacy Policy",
      content: `We reserve the right to modify this privacy policy at any time, in accordance with changes to our services or ${content.application}'s API guidelines. Any updates will be posted here, and we encourage you to review this page regularly to stay informed about how we protect your data.`
    }
  ];

  return (
    <div className="content">
      <Row>
        <Col md="10">
          <Card>
            <CardBody>
              <div style={{ padding: '16px 8px' }}>
                <h1 style={{ fontSize: '1.8rem', marginBottom: '8px' }}>
                  <i className="fas fa-shield-alt" style={{ color: 'var(--airiq-teal)', marginRight: '12px' }}></i>
                  Privacy Policy
                </h1>
                <p style={{ marginBottom: '32px' }}>
                  At {content.brandname}, we value and respect your privacy. This policy outlines the 
                  types of information we collect, how we use it, and the steps we take to protect your 
                  data, in accordance with relevant data protection laws such as the GDPR.
                </p>

                {sections.map((section) => (
                  <div className="privacy-section" key={section.num}>
                    <h2>
                      <span className="numbered-badge">{section.num}</span>
                      {section.title}
                    </h2>
                    <p style={{ paddingLeft: '40px' }}>{section.content}</p>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Privacy;
